import React from "react";
import "../../assets/css/assessmentlanding.css"; // optional – add your styles here
import ResultImg from "../../assets/img/Result_img4.png";
import HeroAssessment from "../../components/HeroAssessment";
import { useNavigate } from "react-router-dom";

const AssessmentLandingPage = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    sessionStorage.removeItem("targets");
    navigate("/");
  };

  // custom-container
  return (
    <>
      <HeroAssessment />
      <div style={{ marginTop: "80px" }}>
        <div className="container min-vh-100 d-flex justify-content-center">
          <div className="row justify-content-center align-items-start w-100">
            {/* Left Column */}
            <div className="col-lg-7 col-md-12 mb-5 text-center text-lg-start">
              <h2 className="assessment-title">Introduction</h2>

              <p className="assessment-text">
                Our Cyber Security Management Maturily tool is for senior
                leadership teams. It helps them to measure their organisational
                cyber security maturity and preparedness, and produce actionable
                management information.
              </p>

              <p className="assessment-text">
                It can also be more useful than traditional, technical due
                diligence for portfolio investors as well as for procurement
                managers looking to secure their supply chain from cyber
                attacks.
              </p>

              <p className="assessment-text">
                This tool is designed to measure your cyber security maturity
                progress. That is, if you jump straight in without having done
                the work first, the results are likely to be disappointing and
                less useful, so please do the prior work first.
              </p>

              <p className="assessment-text">
                If you don't know where to start, we recommend you follow our
                simple{" "}
                <a
                  href="https://www.bee-net.co.uk/company#journey"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span
                    style={{ color: "#7C8C27", textDecoration: "underline" }}
                  >
                    Cyber Maturity Accelerator™
                  </span>
                </a>
                . This can be completed in less than a week in a first iteration
                and doesn't require any technical knowledge. The four steps are:
                Preparation, Agility, Culture and Evaluation, making the acronym
                PACE.
              </p>

              <p className="assessment-text">
                If you'd like to learn more about the Cyber Accelerator, you are
                welcome to join one of our free online seminars or please get in
                touch.
              </p>

              <h2 className="assessment-title" style={{ marginTop: "40px" }}>
                How to score yourself
              </h2>

              <p className="assessment-text">
                We use a simple scale for you to assess yourself against. Be
                aware of flattering yourself, however. You will get more value
                from the tool if you are honest about the maturity of your
                organisation. Note also that this is not an assessment of any
                individual or division within an organisation - it is about the
                collective performance of the whole organisation. Thus, a score
                of 1 is still a good score. It often means that people are
                working hard and know what they should be doing. The higher
                scores show organisational rather than individual maturity.
              </p>

              <ol
                className="assessment-text"
                style={{
                  fontSize: "16px",
                  padding: "14px",
                  marginBottom: "30px",
                }}
              >
                <li className="mb-3"> - Is it in somebody's head?</li>
                <li className="mb-3">
                  {" "}
                  - Is it written down and formally agreed?
                </li>
                <li className="mb-3">
                  {" "}
                  - Is it measured against an organisational objective?
                </li>
                <li className="mb-3"> - Is it optimised?</li>
              </ol>

              <div className="d-flex gap-3 justify-content-center justify-content-lg-start btn-conatiner01">
                <button
                  className="btn btn-back1 px-4"
                  onClick={handleBackClick}
                >
                  Back
                </button>

                <button
                  className="btn btn-start1 px-4"
                  onClick={() => navigate("/user/question-page")}
                >
                  Start Assessment
                </button>
              </div>

              {/* <p className="disclaimer mt-4">
                <strong>Disclaimer:</strong> Lorem ipsum dolor sit amet,
                consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                labore et dolore magna aliqua.
              </p> */}
            </div>

            {/* Right Column */}
            <div className="col-lg-4 col-md-10 d-flex justify-content-center justify-content-lg-end">
              <img src={ResultImg} className="ResultImg" alt="Result" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AssessmentLandingPage;
